import { useEffect, useRef } from "react";
import { isDialogOpen } from "../global-variables/idleFlag";

const IDLE_TIMEOUT = 3 * 60 * 1000;

export const useIdleTimer = (onIdle: () => void) => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const resetTimer = () => {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      if (!isDialogOpen) {
        //console.log("dialog is not open");
        onIdle();
      } else {
        // dialog is open → don’t fire, just restart the countdown
        //console.log("dialog is  open");
        resetTimer();
      }
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, []);
};
